<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <CarfaxLogoContainer v-if="tradeInSourceIsCarfax" />
      <h2 class="mb-4">{{ $t('message.eCommerceV2.tradeInHeading') }}</h2>
      <div class="row form-row pb-2 pt-2">
        <div class="col-sm-6" v-for="(option, index) in tradeInOptions" :key="index">
          <MobialisFancyRadio
            rules="required"
            :textArray="[option]"
            name="tradeInOptions"
            v-model="hasTradeIn"
            :data-cy="option.value"
          ></MobialisFancyRadio>
        </div>
      </div>
      <p class="text-danger small my-0" v-if="!isValid">{{ $t('message.eCommerceV2.pleaseSelect') }}</p>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="next-btn mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { enumMixin } from '@/mixins';
import CarfaxLogoContainer from '@/components/shared/trade-in-carfax/CarfaxLogoContainer.vue';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'TradeInForm',
  components: { CarfaxLogoContainer },
  mixins: [enumMixin],
  data() {
    return {
      hasTradeIn: cloneDeep(this.$store.state.paymentCalculator.hasTradeIn),
      tradeInOptions: this.$t('message.eCommerceV2.tradeInOptions'),
      isValid: true,
    };
  },
  computed: {
    tradeInSourceIsCarfax() {
      return this.$store.getters['business/getTradeInSource'] === TradeInSource.CARFAX;
    },
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        this.isValid = false;
        return;
      }
      this.isValid = true;
      // Make sure the trade in vehicle is removed properly
      if (this.hasTradeIn === this.enums.YesNo.NO) {
        this.$store.commit('trade/RESET_VEHICLE');
        this.$store.commit('paymentCalculator/REMOVE_TRADE');
      }
      this.$store.commit('paymentCalculator/SET_STATE', ['hasTradeIn', this.hasTradeIn]);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
